<template>
  <div>
    <button
      @click="store.toggleFollow(followingId, followingEmail)"
      :class="
        loading || store.loading
          ? 'bg-primary/5 text-primary/50 cursor-not-allowed'
          : store.isFollowing
            ? 'bg-primary-blue text-white cursor-pointer'
            : 'bg-primary text-white cursor-pointer'
      "
      class="flex items-center justify-center space-x-2 px-3.5 text-[15px] h-11 rounded-lg w-full"
    >
      <span>{{
        store.isFollowing ? $t("follow.following") : $t("follow.follow")
      }}</span>
      <Icon name="ph:user-check" size="18" v-if="store.isFollowing" />
      <Icon name="ph:user-plus" size="18" v-else />
    </button>
  </div>
</template>

<script setup lang="ts">
import { useFollowStore } from "~/stores/follow";

const store = useFollowStore();

defineProps<{
  followingId: string;
  loading: boolean;
  followingEmail: string;
}>();
</script>
